export enum TimeOffType {
  HOLIDAY = 10,
  PERSONAL = 20,
  SICK = 30,
  VACATION = 40,
  OTHER = 50,
}

export enum CustomTimeOffType {
  CUSTOM_TIMEOFF_01 = 60,
  CUSTOM_TIMEOFF_02 = 70,
  CUSTOM_TIMEOFF_03 = 80,
  CUSTOM_TIMEOFF_04 = 90,
  CUSTOM_TIMEOFF_05 = 100,
}

export default TimeOffType;
